var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarforward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15894 1.05804C1.54218 0.886464 1.96856 0.820381 2.3895 0.867319C2.81043 0.914257 3.20899 1.07233 3.53976 1.32352L9.03395 5.62229L9.18477 5.77545V1.87491C9.18477 1.6041 9.29827 1.34438 9.5003 1.15289C9.70233 0.961402 9.97635 0.853823 10.2621 0.853823C10.5478 0.853823 10.8218 0.961402 11.0238 1.15289C11.2259 1.34438 11.3394 1.6041 11.3394 1.87491V12.0857C11.3394 12.3566 11.2259 12.6163 11.0238 12.8078C10.8218 12.9993 10.5478 13.1068 10.2621 13.1068C9.97635 13.1068 9.70233 12.9993 9.5003 12.8078C9.29827 12.6163 9.18477 12.3566 9.18477 12.0857V8.18521L9.03395 8.33837L3.53976 12.6371C3.14372 12.9415 2.64917 13.1074 2.13928 13.1068C1.80097 13.1049 1.4669 13.0354 1.15894 12.9026C0.825868 12.7635 0.542097 12.5364 0.341516 12.2485C0.140933 11.9606 0.0320196 11.6241 0.0277824 11.2791V2.68156C0.0320196 2.33659 0.140933 2.00006 0.341516 1.71217C0.542097 1.42428 0.825868 1.19719 1.15894 1.05804ZM2.18237 11.0647L7.37492 6.98033L2.18237 2.98789V11.0647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarforward);
export default __webpack_public_path__ + "static/media/toolbarforward.915ad0226029ba84ddc4ec60924bed25.svg";
export { ForwardRef as ReactComponent };